import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeader } from "./About";

export default function BlogTeaser({ items }) {
  if (!items || !items.length) return null;
  const shown = items.slice(0, 3);
  if (!shown.length) return null;
  return (
    <section id="blog" className="py-24 md:py-32 relative border-t border-white/5" data-testid="blog-teaser-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader number="08" overline="Writing" title="Notes on agents, MLOps, and finance at scale." />
        <div className="mt-14 divide-y divide-white/10 border-y border-white/10">
          {shown.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
            >
              <Link
                to={`/blog/${p.slug}`}
                className="group flex flex-col md:flex-row gap-4 md:items-center justify-between py-8 hover:bg-white/[0.015] transition px-2"
                data-testid={`blog-teaser-${i}`}
              >
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  {p.subsubsection && <span className="tag-chip">{p.subsubsection}</span>}
                  <span className="overline text-volt">{p.ai_assisted ? "AI-ASSISTED" : "HUMAN-WRITTEN"}</span>
                </div>
                <h3 className="font-display font-bold text-2xl sm:text-3xl tracking-tight group-hover:text-volt transition-colors">
                  {p.title}
                </h3>
                {p.excerpt && <p className="mt-2 text-fog-300 max-w-3xl">{p.excerpt}</p>}
              </div>
                <ArrowUpRight className="w-8 h-8 text-fog-300 group-hover:text-volt transition" />
              </Link>
            </motion.div>
          ))}
        </div>
        <div className="mt-10">
          <Link to="/blog" className="btn-ghost" data-testid="blog-view-all">View all posts →</Link>
        </div>
      </div>
    </section>
  );
}
